import React, { useEffect, useRef } from 'react';

import { mount, unmount } from 'redom';

import CarouselSettings from './';

function CarouselSettingsReactWrapper(props) {

  const wrapperReference = useRef(null);
  const componentReference = useRef(null);
  const onChangeReference = useRef(props.onChange);

  onChangeReference.current = props.onChange;

  useEffect(function onLoad() {

    const mountPoint = wrapperReference.current;

    const carouselSettings = new CarouselSettings({
      settings: props.settings,
      onChange(settings) {
        onChangeReference.current(settings);
      }
    });

    componentReference.current = carouselSettings;

    mount(mountPoint, carouselSettings);

    return function onUnload() {
      unmount(mountPoint, componentReference.current);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function renderMain() {

    const mainAttributes = {
      className: 'carousel-settings-react-wrapper',
      ref: wrapperReference
    };

    return <div {...mainAttributes}></div>;

  }

  return renderMain();

}

export default CarouselSettingsReactWrapper;
